export default __webpack_public_path__ + "static/media/desktop-timeline.e0066546.svg";